var _path, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgQr4(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 200,
    height: 200,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "url(#a)",
    d: "M0 0h200v200H0z"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "a",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#b",
    transform: "translate(-.138 -.138) scale(.00862)"
  })), /*#__PURE__*/React.createElement("image", {
    id: "b",
    width: 148,
    height: 148,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAJQAAACUCAIAAAD6XpeDAAAAA3NCSVQICAjb4U/gAAADOElEQVR4nO2dwW7jMAwFN4v+/y+nV18EkCWfnUFmjoFluzvgEpRE+fV+v/8Jk/9Pv4D8HeWBUR4Y5YFRHhjlgVEeGOWBUR4Y5YFRHhjlgVEeGOWBUR6Yn+6A1+u1/hKnNcXTsyprkNex3TXLytg7/x1OGHlglAdGeWDaOe/KZP/LKWec8s3190q+SefF7rMq79DFyAOjPDDKAzPKeVe28tApz3Xvc+WU207PqvxeedaJrb2yRh4Y5YFRHpi1nPcJTHIbESMPjPLAKA/Mx+W87lxfYl2NkheNPDDKA6M8MGs5bys3dOcbK2NPdK/pzs2mMfLAKA+M8sCMct6dNVY3/12ZrNtt5c4ERh4Y5YFRHpjXJ8/ddXNJpa+gm88q938KIw+M8sAoD8yoP2+rfprs50zvBZ2sL3ZzcBcjD4zywCgPzFqd111j+7T5yS26uXmS/4w8MMoDozww7ZyX7mOb5MLK/Sts7ZfZ+ltOGHlglAdGeWBGdV46r2zdZ3JNoj5zblOUR0Z5YOL9eVv7Sib3eWpPpnObckR5YJQHZu2M6W6+2aovE+uRifPPTmM9b/NLUR4Y5YGJnLc5ORv6SnrO8Kl53a09NUYeGOWBUR6Yte8q3Hm28tbaW2VsYq/KaWwXIw+M8sAoD0w753X/j97KB5P5zMo7bM1hTtYLXc/7IpQHRnlg1nrSu9ckvm+XWJPbmodM9A4aeWCUB0Z5YCK9Cona7s6xabZqSiMPjPLAKA9MpM470e0fv7M3/M5e+8rvFYw8MMoDozwwa3Xenet2ifoyQbp2NPLAKA+M8sCs7dus/N4lsRc0Pf/Z3SPTvf8VIw+M8sAoD8xaT/qEU6/6Vs1Xub7LVo/EBCMPjPLAKA9MpM6rkOjpTvTneQ6LRFAeGOWBiZzDciLRn7B1zST/dZ/rGdOiPDLKAxM/Y7pL4hsIXRLzpYn3NPLAKA+M8sB8XM5L9I8/dWa031WQI8oDozwwazkvfZbm5LmJOmwrNzu3+aUoD4zywIy+k75F+uyVO9fnKmM9h0WUR0Z5YEY96fIsRh4Y5YFRHhjlgVEeGOWBUR4Y5YFRHhjlgVEeGOWBUR4Y5YFRHphf1dYyQ1UMRX0AAAAASUVORK5CYII="
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgQr4);
export default __webpack_public_path__ + "static/media/qr-4.866fee9740520cccd6ce6f121ec74ed7.svg";
export { ForwardRef as ReactComponent };